const PrimaryButton = ({ btnText, styles, textColor, onClick }) => {
    return (
        <button onClick={onClick} className={` uppercase tracking-wider ${textColor ? textColor : 'text-black'} font-bold px-5 md:px-7 py-2 rounded-md text-sm flex items-center gap-1 xl:gap-2 bg-gold-600 hover:font-bold hover:tracking-widest transition-all duration-300 ease-in-out text-nowrap ${styles}`}>{btnText}<span className='text-100 font-manrope'>{`>`}</span></button>
    )
}

export default PrimaryButton